(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.qty-control--sm').forEach(function(ctrl) { const input = ctrl.querySelector('.cart-qty-input'); ctrl.querySelector('.cart-qty-minus')?.addEventListener('click', function() { const val = parseInt(input.value); if (val > 0) input.value = val - 1; }); ctrl.querySelector('.cart-qty-plus')?.addEventListener('click', function() { input.value = parseInt(input.value) + 1; }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) { sortSelect.addEventListener('change', function() { const url = new URL(window.location.href); url.searchParams.set('sort_by', this.value); window.location.href = url.toString(); }); }
  const filtersToggle = document.getElementById('filters-toggle');
  const filtersPanel  = document.getElementById('collection-filters');
  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', function() { const open = filtersPanel.classList.toggle('is-open'); filtersToggle.setAttribute('aria-expanded', open); filtersPanel.setAttribute('aria-hidden', !open); });
    if (window.matchMedia('(min-width: 901px)').matches) { filtersPanel.classList.add('is-open'); filtersPanel.setAttribute('aria-hidden', 'false'); filtersToggle.setAttribute('aria-expanded', 'true'); }
  }
  document.querySelectorAll('.filter-value__input').forEach(function(input) {
    input.addEventListener('change', function() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams();
      if (url.searchParams.get('sort_by')) params.set('sort_by', url.searchParams.get('sort_by'));
      document.querySelectorAll('.filter-value__input:checked').forEach(function(c) { params.append(c.name, c.value); });
      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-section"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const bar = document.getElementById('announcement-bar');
    const btn = document.getElementById('announcement-close');
    if (!bar || !btn) return;
    const key = 'crucible-announcement-dismissed-{{ section.id }}';
    if (sessionStorage.getItem(key)) { bar.classList.add('is-hidden'); return; }
    btn.addEventListener('click', function() { bar.classList.add('is-hidden'); sessionStorage.setItem(key, '1'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.getElementById('mobile-menu-toggle');
  const menu   = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      menu.setAttribute('aria-hidden', !open);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const qtyInput = document.getElementById('product-qty');
    const qtyHidden = document.getElementById('product-qty-hidden');
    if (qtyInput && qtyHidden) { qtyInput.addEventListener('input', function() { qtyHidden.value = this.value; }); }
    document.getElementById('qty-minus')?.addEventListener('click', function() { if (qtyInput && parseInt(qtyInput.value) > 1) { qtyInput.value = parseInt(qtyInput.value) - 1; if (qtyHidden) qtyHidden.value = qtyInput.value; } });
    document.getElementById('qty-plus')?.addEventListener('click', function() { if (qtyInput) { qtyInput.value = parseInt(qtyInput.value) + 1; if (qtyHidden) qtyHidden.value = qtyInput.value; } });
    document.querySelectorAll('.product-media__thumb').forEach(function(btn) { btn.addEventListener('click', function() { const img = document.getElementById('product-featured-image'); if (img) { img.src = this.dataset.imageUrl; img.alt = this.dataset.imageAlt; } document.querySelectorAll('.product-media__thumb').forEach(function(b) { b.classList.remove('is-active'); }); this.classList.add('is-active'); }); });
    const variantsJson = document.getElementById('product-variants-json');
    if (!variantsJson) return;
    const variants = JSON.parse(variantsJson.textContent);
    const optionGroups = document.querySelectorAll('.product-option__values');
    const variantIdInput = document.getElementById('product-variant-id');
    const priceEl = document.getElementById('product-price');
    const atcBtn = document.getElementById('product-atc');
    const skuEl = document.getElementById('product-sku');
    function getSelectedOptions() { return Array.from(optionGroups).map(function(g) { const b = g.querySelector('.product-option__btn.is-selected'); return b ? b.dataset.optionValue : null; }); }
    function findVariant(opts) { return variants.find(function(v) { return v.options.every(function(o, i) { return o === opts[i]; }); }); }
    function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
    function updateVariant() { const v = findVariant(getSelectedOptions()); if (!v) return; if (variantIdInput) variantIdInput.value = v.id; if (priceEl) { priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price ? '<span class="product-price__compare">' + fmt(v.compare_at_price) + '</span><span class="product-price__current product-price__current--sale">' + fmt(v.price) + '</span>' : '<span class="product-price__current">' + fmt(v.price) + '</span>'; } if (atcBtn) { atcBtn.disabled = !v.available; atcBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; } if (skuEl && v.sku) skuEl.querySelector('span').textContent = v.sku; if (v.featured_image) { const img = document.getElementById('product-featured-image'); if (img) img.src = v.featured_image.src; } }
    optionGroups.forEach(function(group, gi) { group.querySelectorAll('.product-option__btn').forEach(function(btn) { btn.addEventListener('click', function() { group.querySelectorAll('.product-option__btn').forEach(function(b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); }); this.classList.add('is-selected'); this.setAttribute('aria-pressed', 'true'); const lbl = document.getElementById('option-selected-' + (gi + 1)); if (lbl) lbl.textContent = this.dataset.optionValue; updateVariant(); }); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const searchSortSelect = document.getElementById('search-sort-select');
  if (searchSortSelect) { searchSortSelect.addEventListener('change', function() { const url = new URL(window.location.href); url.searchParams.set('sort_by', this.value); window.location.href = url.toString(); }); }
  const searchToggle = document.getElementById('search-filters-toggle');
  const searchPanel  = document.getElementById('search-filters');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function() { const open = searchPanel.classList.toggle('is-open'); searchToggle.setAttribute('aria-expanded', open); searchPanel.setAttribute('aria-hidden', !open); });
    if (window.matchMedia('(min-width: 901px)').matches) { searchPanel.classList.add('is-open'); searchPanel.setAttribute('aria-hidden', 'false'); searchToggle.setAttribute('aria-expanded', 'true'); }
  }
  document.querySelectorAll('.search-filter-input').forEach(function(input) {
    input.addEventListener('change', function() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams();
      params.set('q', url.searchParams.get('q') || '');
      params.set('type', 'product');
      if (url.searchParams.get('sort_by')) params.set('sort_by', url.searchParams.get('sort_by'));
      document.querySelectorAll('.search-filter-input:checked').forEach(function(c) { params.append(c.name, c.value); });
      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
